import Error from 'next/error'
import { PAGINEDETAIL, MOTIVAZIONI, REPARTI, NAZIONI, PAGINA_CONTATTI_DATA } from '../../utils/endpoint'
import { getApiClient } from '../../utils'
import React from 'react'
import PropTypes from 'prop-types'
import ContattiTemplate from '../../components/template/ContattiTemplate/ContattiTemplate'


const Contatti = ({ page, statusCode, motivazioni, reparti, nazioni, contattiData, locale }) => {
  if (!page) return <Error statusCode={statusCode} />

  return (
    <>
      <ContattiTemplate
        contattaciMenu={contattiData}
        motivazioni={motivazioni}
        reparti={reparti}
        nazioni={nazioni}
        page={page}
      />
    </>
  )
}

export async function getServerSideProps({ params, locale, req }) {
  const api = getApiClient(req)
  const pageResponse = await api.get(PAGINEDETAIL, { params: { chiave: 'contatti', lang: locale } })
  const page = await pageResponse.data

  const motivazioniResponse = await api.get(MOTIVAZIONI, {
    params: { lang: locale },
  })
  const motivazioni = await motivazioniResponse.data

  const repartiResponse = await api.get(REPARTI, {
    params: { lang: locale },
  })
  const reparti = await repartiResponse.data

  const nazioniResponse = await api.get(NAZIONI, {
    params: { lang: locale },
  })
  const nazioni = await nazioniResponse.data

  const contattiDataResponse = await api.get(PAGINA_CONTATTI_DATA, { params: { lang: locale } })
  const contattiData = await contattiDataResponse.data

  const toolbarProps = { toolbarPage: page }
  return {
    props: { page, motivazioni, reparti, nazioni, contattiData, ...toolbarProps, locale },
  }
}

Contatti.propTypes = {
  page: PropTypes.object,
  statusCode: PropTypes.number,
}

export default Contatti
